var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSauceSectionTextBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 764.302,
    height: 461.227,
    viewBox: "0 0 764.302 461.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#ff7350;}.a,.b{fill-rule:evenodd;}.b,.f{fill:#ebebeb;}.c{fill:#ffe375;}.e{fill:#ffefaf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.351 -6.659)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.075,221.475c1.238-1.238,2.48-2.469,3.71-3.713a3.771,3.771,0,0,0,.007-5.787q-3.471-3.5-6.971-6.97a3.674,3.674,0,0,0-5.564-.049q-3.8,3.754-7.553,7.551a3.976,3.976,0,0,0,.011,5.988q3.363,3.41,6.771,6.774a3.813,3.813,0,0,0,5.746.044c1.291-1.269,2.562-2.559,3.843-3.838",
    transform: "translate(7 65.662)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.605,34.539c.2,1.7.391,3.4.607,5.1a10.044,10.044,0,0,1-8.363,11.369,10.206,10.206,0,0,1-11.965-7.6c-.473-1.965-.725-3.982-1.1-5.973A13.969,13.969,0,0,0,30.135,26.234a28.146,28.146,0,0,1-5.565.435c-4.274-.269-7.088-2.96-7.954-7.271a9.86,9.86,0,0,1,1.134-6.946c1.258-2.156,3.827-3.435,6.13-4.177A38.744,38.744,0,0,1,35.1,6.662a35.532,35.532,0,0,1,12,1.86A28.391,28.391,0,0,1,64.3,25.035a56.735,56.735,0,0,1,2.3,9.5",
    transform: "translate(-1.452)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 7.174,
    cy: 7.174,
    r: 7.174,
    transform: "translate(53.153 102.921)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 9.865,
    cy: 9.865,
    r: 9.865,
    transform: "translate(679.038 272.743)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 53.807,
    height: 17.936,
    rx: 8.968,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 670.951, 87.848)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 80.711,
    height: 17.936,
    rx: 8.968,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 31.992, 413.763)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 74.433,
    height: 24.811,
    rx: 12.406,
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 712.681, 404.868)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSauceSectionTextBg);
export default __webpack_public_path__ + "static/media/sauce-section-text-bg.8cd6ed71b3dfb69101aaeb37eca87170.svg";
export { ForwardRef as ReactComponent };